import { IBuilder } from '../types/newbuilding/builder';
import { ISeller } from '../types/newbuilding/seller';

export const getWorkTime = (agent?: IBuilder | ISeller | null) => {
  const workTime = agent && agent.workTimeDetailed;

  return {
    callFrom: workTime?.callFrom,
    callTo: workTime?.callTo,
    timezone: workTime?.timezone,
  };
};
